import React from 'react'
import { MtLogo, MtBusinessLogo } from '../logos'
import PropTypes from 'prop-types'

const TenantLogo = ({ tenant, height = 60, mtLogo, className = {} }) => {
  const imgixCropParams = Object.entries(tenant.logo?.imgixCropParams ?? {})
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  if (tenant.logo?.imgUrl && tenant?.tenantType !== 'public') {
    return (
      <img
        src={`${tenant.logo.imgUrl}&h=${height}&${imgixCropParams}`}
        alt={tenant.logo?.altText ?? `${tenant.name} Logo`}
        height={height}
        className={className}
      />
    )
  }

  if (mtLogo === 'mt-club') {
    return <MtLogo height={height} className={className} />
  }

  if (mtLogo === 'mt-business') {
    return <MtBusinessLogo height={height} className={className} />
  }

  return <MtLogo height={height} className={className} />
}

TenantLogo.propTypes = {
  mtLogo: PropTypes.oneOf(['mt-club', 'mt-business'])
}

export default TenantLogo
